import {FC} from 'react'
import {Button} from '../Button/Button'

interface IBackButtonProps {
  onClick: () => void
  color?: 'blue' | 'purple' | 'orange' | 'black'
}

export const BackButton: FC<IBackButtonProps> = ({onClick, color = 'blue'}) => {
  return (
    <div className="fixed right-[24px] top-[24px] z-50">
      <Button size="small" color={color} ignoreMinWidth onClick={onClick} id="go-back-btn">
        Tilbake
      </Button>
    </div>
  )
}
